import ViewFlightContainer from './ViewFlightContainer';

export default ViewFlightContainer;
